import { useEffect, useRef, useCallback } from "react";
import {
    AccountInfo,
} from "@azure/msal-browser";

import { msalInstance } from "..";
import { isE2EModeEnabled } from "../utils/runtimeMode";




const IDLE_TIMEOUT = 8 * 60 * 60 * 1000 //defaulting to 8hrs ( change values to test locally )

export const useSessionManager = ({ disabled = false }: { disabled?: boolean } = {}) => {
    const idleTimerRef = useRef<NodeJS.Timeout | null>(null);


    const clearTimer = () => {
        if(idleTimerRef.current) {
            clearTimeout(idleTimerRef.current);
            idleTimerRef.current = null;
        }

    };


    const handleLogout = useCallback(async () => {
        const account: AccountInfo | null = msalInstance.getActiveAccount();
        if(account) {
            try {
                console.warn("Logging out due to idle timeout or token failure");
                await msalInstance.logoutRedirect({
                    account,
                    postLogoutRedirectUri: "/",
                });
            } catch(err){
                console.error("Logout redirect failed, forcing reload", err);
                msalInstance.clearCache();
                window.location.href = "/";
            }
        }
        else {
            return;
        }
    }, []);


    const resetIdleTimer = useCallback(() => {
        if (disabled || isE2EModeEnabled()) return;
        if(!msalInstance.getActiveAccount()) return;
        clearTimer();

        if(idleTimerRef.current) clearTimeout(idleTimerRef.current);
        idleTimerRef.current = setTimeout(handleLogout, IDLE_TIMEOUT);
    },[handleLogout]);

        


    useEffect(() => {
        if (disabled || isE2EModeEnabled()) {
            return;
        }

        const events = [
            "mousedown", "mousemove", "keydown", "touchstart", "scroll", "wheel", "visibilitychange", "focus", "blur"
        ];

        events.forEach((e) =>
        window.addEventListener(e,resetIdleTimer, {passive: true})
     );

     resetIdleTimer();

     return() => {
        events.forEach((e) => 
            window.removeEventListener(e, resetIdleTimer)
    );
    if(idleTimerRef.current) window.clearTimeout(idleTimerRef.current);
     };
    }, [disabled, resetIdleTimer]);

}